<template>
  <b-progress height="2rem" :max="max">
    <b-progress-bar :value="value">
      <span v-if="message"><i class="fal fa-spinner fa-spin"></i> {{ message }}</span>
    </b-progress-bar>
  </b-progress>
</template>

<script>
  export default {
    name: 'CartCheckoutProcess',
    props: ['message', 'value', 'max'],
    data() {
      return {}
    },
    methods: {},
    mounted() {}
  }
</script>
